module.exports = __webpack_public_path__ + "static/media/shopee-logo.8617c6c5.png";